var map = {
	"./appointments.svg": "578a",
	"./dashboard.svg": "b5a1",
	"./duplicate.svg": "99e3",
	"./enquiries.svg": "027e",
	"./events.svg": "af52",
	"./graph.svg": "34dd",
	"./marketing.svg": "b812",
	"./messages.svg": "8426",
	"./news.svg": "037c",
	"./payment.svg": "7722",
	"./settings.svg": "057d",
	"./shop.svg": "720b",
	"./subscriptions.svg": "7abb",
	"./users.svg": "f250"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78a1";